import { getLabel } from '@/i18n/maps';
import type { Locale } from '@/types/widget';

export interface ResultNoMatchProps {
  locale: Locale;
  onOpenChat: () => void;
  /** The user's search term, interpolated into the prompt. */
  query?: string;
}

export function ResultNoMatch({
  locale,
  onOpenChat,
  query,
}: ResultNoMatchProps): JSX.Element {
  const term = (query ?? '').trim();
  const question = getLabel('nomatch_question', locale).replace(
    '{terme}',
    term || '…',
  );

  return (
    <div className="tw-px-5 tw-py-4">
      <p className="tw-text-[14px] tw-text-cal-ink tw-leading-relaxed">{question}</p>
      <button
        type="button"
        onClick={onOpenChat}
        content-content="chatbot-overview-chat"
        className="gtmtrack tw-group tw-mt-1.5 tw-inline-flex tw-items-center tw-gap-1 tw-text-[14px] tw-font-semibold tw-text-cal-green-700 hover:tw-text-cal-green-900 tw-transition-colors"
      >
        {getLabel('nomatch_cta', locale)}
        <span className="tw-transition-transform group-hover:tw-translate-x-0.5">→</span>
      </button>
    </div>
  );
}
